import React from 'react'
import styled from 'styled-components'
import { Row, Column } from '../Grid'
import { Text } from '../Text'
import { Image } from '../Image'
import { checkIsMobile } from 'utils/helpers'

const PageTitleSEO = ({ seoDataFind }) => {
  return (
    <Title>
      <Row
        display={['block', 'flex']}
        as='section'
        px={['17px', '10px']}
        pt='21px'
        width={['100%', '1140px']}
        bg='white'
      >
        {seoDataFind?.image && !checkIsMobile(994) && (
          <TitleImage src={seoDataFind.image} mr='34px' />
        )}
        <Text>
          <Text fontSize='32px' fontWeight='600' mb='21px' textAlign='left' color='secondary'>
            {seoDataFind?.title}
            <Text
              as='span'
              variant={['biggest']}
              fontWeight='600'
              ml='10px'
              textAlign='left'
              color='primary'
            >
              {seoDataFind?.slug}
            </Text>
          </Text>
          <Text maxWidth='850px' variant='regular' textAlign='left' color='#718797'>
            {seoDataFind?.text.map(value => (
              <Text mb='37px'>{value}</Text>
            ))}
          </Text>
        </Text>
      </Row>
    </Title>
  )
}

const Title = styled(Row)`
  justify-content: center;
  background: #fff;
`

const TitleImage = styled(Image)`
  border-radius: 8px;
  width: 100% !important;
`

export default PageTitleSEO
